import { useState, useEffect, useRef } from "react";
import { authFetch } from "../../App";
import { API, KONTAKTART_OPTIONS, KONTAKTART_COLORS } from "./helpers";

export function InlineKontaktart({ value, contactId, onChanged }) {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const ref = useRef(null);
  const badgeRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target) && badgeRef.current && !badgeRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  const toggle = (e) => {
    e.stopPropagation();
    if (!open && badgeRef.current) {
      const rect = badgeRef.current.getBoundingClientRect();
      setPos({ top: rect.bottom + 2, left: rect.left });
    }
    setOpen(!open);
  };

  const select = async (art) => {
    setOpen(false);
    if (art === value) return;
    await authFetch(`${API}/crm/contacts/${contactId}`, {
      method: "PUT", body: JSON.stringify({ kontaktart: art }),
    });
    onChanged();
  };

  const colorCls = KONTAKTART_COLORS[value] || KONTAKTART_COLORS.Sonstiges;

  return (
    <>
      <span
        ref={badgeRef}
        className={`text-[9px] px-1.5 py-0.5 rounded font-medium cursor-pointer border ${colorCls} hover:opacity-80`}
        onClick={toggle}
        data-testid={`kontaktart-badge-${contactId}`}
      >
        {value || "—"}
      </span>
      {open && (
        <div
          ref={ref}
          className="fixed z-[9999] bg-white border border-gray-200 rounded shadow-lg py-0.5 min-w-[120px]"
          style={{ top: pos.top, left: pos.left }}
          data-testid={`kontaktart-dropdown-${contactId}`}
        >
          {KONTAKTART_OPTIONS.map((opt) => {
            const optColor = KONTAKTART_COLORS[opt];
            return (
              <div
                key={opt}
                className={`px-2.5 py-1 text-[11px] cursor-pointer hover:bg-gray-50 flex items-center gap-2 ${opt === value ? "font-semibold" : ""}`}
                onClick={(e) => { e.stopPropagation(); select(opt); }}
                data-testid={`kontaktart-option-${opt}`}
              >
                <span className={`w-2 h-2 rounded-full ${optColor.split(" ")[1]}`} />
                {opt}
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}
